export default __webpack_public_path__ + "static/media/PioLogo.fb368744.png";